import React, { useContext } from 'react'
import { Box, Container } from '@material-ui/core'
import { ThemeContext } from 'styled-components'
// import logo_image from '../../assets/images/cropto_logo.svg'
// import styled from 'styled-components'
// import { NavLink } from 'react-router-dom'

// const StyledNavLink = styled(NavLink)`
//   outline: none;
//   cursor: pointer;
//   text-decoration: none;
//   color: ${({ theme }) => theme.text8};
//   font-size: 14px;
//   font-weight: 300;
//   margin-top: 9.51px
//   display:block
// `
export default function Footer() {
  const theme = useContext(ThemeContext)
  return (
    <Box className="" style={{ width: '100%', background: theme.bg7 }}>
      <Container style={{ position: 'relative', margin: 'auto' }} maxWidth="xl">
        <Box
          sx={{
            paddingTop: { xs: '29px', lg: '62px', xl: '62px' },
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            paddingBottom: { sm: '72px', md: '0px' },
          }}
        >
          <Box sx={{ width: '100%', display: { xl: 'flex', md: 'flex' }, justifyContent: 'between' }}>
            <Box sx={{ width: { sm: '100%', xl: '70%' }, display: { xl: 'flex' } }}>
              {/* <Box sx={{ width: { sm: '100%', xl: '30%' } }}>
                <img src={logo_image}></img>
                <Box
                  sx={{
                    fontSize: '14px',
                    fontWeight: 300,
                    lineHeight: '18.7px',
                    letterSpacing: '0.48px',
                    marginTop: '14px',
                    color: theme.text8,
                    maxWidth: { xs: '380px', xl: '220px' }
                  }}
                >
                  Cropto is the agricultural product-based crypto asset brand of AgriFintech Finansal Teknolojiler A.Ş.
                </Box>
              </Box> */}
              <Box
                sx={{
                  width: { sm: '100%', xl: '70%' },
                  display: { xl: 'flex', sm: 'flex' },
                  justifyContent: { md: 'center' },
                }}
              >
                <Box sx={{ width: '25%' }}>
                  <Box
                    sx={{
                      color: theme.primary1,
                      marginTop: { xs: '28px', sm: '20px', xl: '8px' },
                      marginBottom: '18.8px',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '20.8px',
                      letterSpacing: '0.48px',
                    }}
                  >
                    CORPORATE
                  </Box>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/about-cropto'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    About Cropto
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/why-cropto'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Why Cropto?
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/how-to-invest'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    How to invest?
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/ceo-message'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    CEO Message
                  </a>

                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/press-releases'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Press Releases
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/insights'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Insights
                  </a>
                </Box>
                <Box sx={{ width: '25%' }}>
                  <Box
                    sx={{
                      color: theme.primary1,
                      marginTop: { xs: '15px', sm: '20px', xl: '8px' },
                      marginBottom: '18.8px',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '20.8px',
                      letterSpacing: '0.48px',
                    }}
                  >
                    TOKENS
                  </Box>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/tokens/cropto-wheat-token'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Wheat Token
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/tokens/cropto-barley-token'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Barley Token
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/tokens/cropto-corn-token'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Corn Token
                  </a>

                  <a
                    target="_blank"
                    href={'https://www.cropto.io/tokens/cropto-hazelnut-token'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Hazelnut Token
                  </a>

                  <a
                    target="_blank"
                    href={'https://www.cropto.io/tokens/cropto-bean-token'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Bean Token
                  </a>

                  <a
                    target="_blank"
                    href={'https://www.cropto.io/corporate/cropto-token-family'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    See All
                  </a>
                </Box>

                <Box sx={{ width: '25%' }}>
                  <Box
                    sx={{
                      color: theme.primary1,
                      marginTop: { xs: '15px', sm: '20px', xl: '8px' },
                      marginBottom: '18.8px',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '20.8px',
                      letterSpacing: '0.48px',
                    }}
                  >
                    TRANSPARENCY
                  </Box>
                  <a
                    target="_blank"
                    href={
                      'https://cdn.prod.website-files.com/67275cd183b156809f915f2e/672af268546851ae6e03f64c_666359421de0aeba878d112e_Cropto_2024_Website_Whitepaper_EN_070624.pdf'
                    }
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Cropto Witepaper
                  </a>
                  <a
                    target="_blank"
                    href={
                      'https://cdn.prod.website-files.com/67275cd183b156809f915f2e/675fb8b14f81bca0583d44a2_technical-auidit-report.pdf'
                    }
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      whiteSpace: 'nowrap',
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Technical Audit Report
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/transparency/proof-of-reserve-por-audit-reports'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      whiteSpace: 'nowrap',
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    (PoR) Audit Reports
                  </a>

                  <a
                    target="_blank"
                    href={
                      'https://cdn.prod.website-files.com/67275cd183b156809f915f2e/675fb8e297ba9f6d03830f75_physical-delivery-report-EN.pdf'
                    }
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      whiteSpace: 'nowrap',
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Phy. Product Delivery Report
                  </a>
                </Box>
                <Box sx={{ width: '25%' }}>
                  <Box
                    sx={{
                      color: theme.primary1,
                      marginTop: { xs: '15px', sm: '20px', xl: '8px' },
                      marginBottom: '18.8px',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '20.8px',
                      letterSpacing: '0.48px',
                    }}
                  >
                    LEGAL
                  </Box>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/legal/user-aggrement'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    User Aggreement
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/legal/clarification-text'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Clarification Text
                  </a>
                  <a
                    target="_blank"
                    href={'https://www.cropto.io/legal/risk-disclosure'}
                    style={{
                      fontWeight: 300,
                      fontSize: '14px',
                      lineHeight: '18.72px',
                      letterSpacing: '0.48px',
                      color: theme.text8,
                      textDecoration: 'none',
                      display: 'block',
                      marginTop: '9.51px',
                    }}
                  >
                    Risk Disclosure
                  </a>
                </Box>
              </Box>
            </Box>
            <Box sx={{ width: { xl: '30%' }, paddingRight: '27px' }}>
              <Box
                sx={{
                  width: '100%',
                  textAlign: { xs: 'left', md: 'right' },
                  marginTop: { xs: '15px', sm: '20px', md: '0px' },
                }}
              >
                <Box
                  sx={{
                    color: theme.primary1,
                    marginTop: '8px',
                    marginBottom: '18.8px',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '20.8px',
                    letterSpacing: '0.48px',
                  }}
                >
                  Follow us!
                </Box>
                <Box
                  sx={{
                    marginTop: '19.72px',
                    display: 'flex',
                    justifyContent: { xs: 'start', md: 'end' },
                    alignItems: 'center ',
                    zIndex: 10,
                    position: 'relative',
                  }}
                >
                  <Box sx={{ marginRight: '15px' }}>
                    <a href="https://twitter.com/cropto_io" target="_blank">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3462_2891)">
                          <path
                            d="M14.2833 10.1623L23.2178 0H21.1006L13.3427 8.82385L7.14656 0H0L9.36982 13.3432L0 24H2.11732L10.3098 14.6817L16.8534 24H24L14.2827 10.1623H14.2833ZM2.88021 1.55963H6.13227L21.1016 22.5113H17.8495L2.88021 1.55963Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3462_2891">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                  <Box sx={{ marginRight: '15px' }}>
                    <a href="https://t.me/cropto_official" target="_blank">
                      <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3462_2894)">
                          <path
                            d="M0.474828 11.6528L7.18218 14.9956C7.30942 15.0588 7.45034 15.0895 7.59235 15.0849C7.73435 15.0803 7.873 15.0406 7.99589 14.9693L13.9661 11.4985L10.3524 14.7008C10.2616 14.7813 10.1888 14.8801 10.1389 14.9909C10.0891 15.1016 10.0633 15.2216 10.0633 15.343V23.1429C10.0633 23.9658 11.1136 24.3121 11.6061 23.6584L14.5055 19.8036L21.6757 23.8869C21.7936 23.954 21.9257 23.9921 22.0611 23.9981C22.1965 24.0042 22.3315 23.978 22.4549 23.9218C22.5782 23.8656 22.6865 23.7809 22.7708 23.6747C22.8551 23.5685 22.913 23.4439 22.9397 23.3109L27.4117 1.02547C27.4419 0.874659 27.431 0.718497 27.38 0.573363C27.3291 0.428229 27.2401 0.29947 27.1223 0.200592C27.0045 0.101713 26.8622 0.0363572 26.7104 0.0113787C26.5587 -0.0135997 26.403 0.00271949 26.2597 0.0586249L0.545684 10.0871C0.391064 10.1474 0.257276 10.2513 0.160565 10.3862C0.0638544 10.521 0.00837972 10.6811 0.000876611 10.8469C-0.0066265 11.0127 0.0341647 11.1771 0.118298 11.3201C0.202431 11.4632 0.326286 11.5788 0.474828 11.6528ZM25.4231 2.22546L21.4929 21.8104L14.6987 17.9407C14.5173 17.8379 14.3048 17.8045 14.1006 17.8468C13.8964 17.889 13.7146 18.0041 13.589 18.1704L11.7776 20.5784V15.7282L21.55 7.06998C22.3237 6.38541 21.4346 5.16828 20.5512 5.68714L7.53418 13.2551L2.97194 10.9819L25.4231 2.22546Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3462_2894">
                            <rect width="27.4284" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                  <Box sx={{ marginRight: '15px' }}>
                    <a href="https://www.instagram.com/cropto.io" target="_blank">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3462_2897)">
                          <path
                            d="M17.5034 0H6.49659C2.91431 0 0 2.91431 0 6.49659V17.5036C0 21.0857 2.91431 24 6.49659 24H17.5036C21.0857 24 24 21.0857 24 17.5036V6.49659C24 2.91431 21.0857 0 17.5034 0ZM22.593 17.5036C22.593 20.3099 20.3099 22.593 17.5034 22.593H6.49659C3.69014 22.593 1.407 20.3099 1.407 17.5036V6.49659C1.407 3.69014 3.69014 1.407 6.49659 1.407H17.5036C20.3099 1.407 22.593 3.69014 22.593 6.49659V17.5036Z"
                            fill={theme.text8}
                          />
                          <path
                            d="M12 5.43776C8.38149 5.43776 5.43768 8.38152 5.43768 12.0001C5.43768 15.6187 8.38144 18.5624 12 18.5624C15.6186 18.5624 18.5623 15.6187 18.5623 12.0001C18.5623 8.38152 15.6186 5.43776 12 5.43776ZM12 17.1554C9.1575 17.1554 6.84469 14.8428 6.84469 12.0001C6.84469 9.15758 9.1575 6.84476 12 6.84476C14.8427 6.84476 17.1553 9.15758 17.1553 12.0001C17.1553 14.8428 14.8427 17.1554 12 17.1554ZM18.7193 3.10718C17.6499 3.10718 16.7802 3.97713 16.7802 5.04626C16.7802 6.11562 17.6499 6.98553 18.7193 6.98553C19.7886 6.98553 20.6585 6.11562 20.6585 5.04631C20.6585 3.97699 19.7886 3.10718 18.7193 3.10718ZM18.7193 5.57839C18.4259 5.57839 18.1871 5.3396 18.1871 5.04626C18.1871 4.75277 18.4259 4.51418 18.7193 4.51418C19.0128 4.51418 19.2515 4.75277 19.2515 5.04626C19.2515 5.3396 19.0128 5.57839 18.7193 5.57839Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3462_2897">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                  <Box sx={{ marginRight: '15px' }}>
                    <a href="https://www.youtube.com/@cropto_io" target="_blank">
                      <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3459_2844)">
                          <path
                            d="M20.7207 10.5823L13.7203 6.75199C13.3177 6.53173 12.842 6.53996 12.4475 6.77371C12.0527 7.00771 11.8172 7.42112 11.8172 7.87996V15.4748C11.8172 15.9315 12.0513 16.3442 12.4434 16.5784C12.6481 16.7007 12.8751 16.7622 13.1026 16.7622C13.3155 16.7618 13.5249 16.7086 13.7121 16.6072L20.7127 12.8429C20.9166 12.7333 21.0872 12.5706 21.2063 12.3721C21.3254 12.1736 21.3888 11.9466 21.3896 11.7151C21.3905 11.4835 21.3289 11.256 21.2111 11.0566C21.0934 10.8572 20.9239 10.6933 20.7207 10.5823ZM13.6741 14.5194V8.84313L18.9061 11.7059L13.6741 14.5194Z"
                            fill={theme.text8}
                          />
                          <path
                            d="M31.4536 5.66443L31.4522 5.64995C31.4253 5.39491 31.1582 3.12634 30.0554 1.97243C28.7806 0.615229 27.3353 0.450359 26.6403 0.371328C26.5878 0.365532 26.5353 0.35924 26.4829 0.352452L26.4276 0.346697C22.2386 0.0420839 15.9122 0.000495104 15.8489 0.000247552L15.8433 0L15.8378 0.000247552C15.7745 0.000495104 9.44808 0.0420839 5.22131 0.346697L5.16549 0.352452C5.12049 0.358517 5.07092 0.364087 5.01702 0.3704C4.33 0.449617 2.90026 0.614796 1.6219 2.02102C0.571474 3.1626 0.267851 5.38259 0.23666 5.63206L0.23307 5.66443C0.223602 5.77057 0 8.29714 0 10.8336V13.2046C0 15.7411 0.223602 18.2676 0.23307 18.374L0.234741 18.3899C0.261601 18.6409 0.528462 20.8679 1.62623 22.0222C2.82488 23.334 4.34039 23.5076 5.15558 23.6009C5.28443 23.6156 5.3954 23.6282 5.47103 23.6415L5.5443 23.6516C7.96301 23.8818 15.5465 23.9951 15.868 23.9998L15.8777 24L15.8873 23.9998C15.9507 23.9995 22.2768 23.9579 26.4659 23.6533L26.5212 23.6475C26.5742 23.6405 26.6336 23.6342 26.6989 23.6274C27.3821 23.5549 28.8041 23.4043 30.0648 22.0171C31.1152 20.8754 31.4191 18.6553 31.45 18.4061L31.4536 18.3738C31.4631 18.2674 31.6869 15.741 31.6869 13.2046V10.8336C31.6867 8.29708 31.4631 5.77081 31.4536 5.66443ZM29.8298 13.2046C29.8298 15.5523 29.6248 17.97 29.6054 18.1919C29.5267 18.8034 29.2063 20.2079 28.6945 20.7642C27.9054 21.6323 27.0949 21.7184 26.5031 21.781C26.4371 21.7878 26.3712 21.7952 26.3053 21.8032C22.2536 22.0962 16.1661 22.1411 15.8857 22.1429C15.5712 22.1383 8.09861 22.0239 5.75367 21.8061C5.63348 21.7865 5.50364 21.7715 5.36687 21.7561C4.6728 21.6765 3.72269 21.5677 2.99216 20.7642L2.97496 20.7458C2.47212 20.2219 2.16101 18.9085 2.08191 18.1992C2.06718 18.0315 1.85689 15.5851 1.85689 13.2046V10.8336C1.85689 8.48863 2.06143 6.07351 2.08123 5.847C2.1753 5.12681 2.50164 3.80735 2.99216 3.274C3.80537 2.37953 4.66289 2.28045 5.23004 2.21491C5.28419 2.2086 5.33469 2.20284 5.38135 2.19678C9.49208 1.90231 15.6233 1.85856 15.8433 1.85689C16.0634 1.85831 22.1924 1.90231 26.2666 2.19678C26.3167 2.20309 26.3713 2.20934 26.43 2.21615C27.0134 2.28262 27.895 2.38319 28.7042 3.24621L28.7117 3.2542C29.2146 3.77808 29.5257 5.11449 29.6047 5.83802C29.6188 5.9964 29.8298 8.44797 29.8298 10.8336V13.2046Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3459_2844">
                            <rect width="31.6869" height="24" rx="4" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                  <Box sx={{ marginRight: '15px' }}>
                    <a href="https://www.linkedin.com/company/cropto" target="_blank">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3463_2901)">
                          <path
                            d="M3.03734 23.25H20.9627C22.1984 23.25 23.25 22.1984 23.25 20.9627V3.03734C23.25 1.80158 22.1984 0.75 20.9627 0.75H3.03734C1.80158 0.75 0.75 1.80158 0.75 3.03734V20.9627C0.75 22.1984 1.80158 23.25 3.03734 23.25Z"
                            stroke={theme.text8}
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6.394 6.768C6.022 6.768 5.71 6.642 5.458 6.39C5.206 6.138 5.08 5.826 5.08 5.454C5.08 5.082 5.206 4.77 5.458 4.518C5.71 4.266 6.022 4.14 6.394 4.14C6.754 4.14 7.06 4.266 7.312 4.518C7.564 4.77 7.69 5.082 7.69 5.454C7.69 5.826 7.564 6.138 7.312 6.39C7.06 6.642 6.754 6.768 6.394 6.768ZM7.402 8.082V18H5.35V8.082H7.402ZM15.1001 7.92C15.8801 7.92 16.5761 8.082 17.1881 8.406C17.8121 8.73 18.2981 9.21 18.6461 9.846C18.9941 10.482 19.1681 11.25 19.1681 12.15V18H17.1341V12.456C17.1341 11.568 16.9121 10.89 16.4681 10.422C16.0241 9.942 15.4181 9.702 14.6501 9.702C13.8821 9.702 13.2701 9.942 12.8141 10.422C12.3701 10.89 12.1481 11.568 12.1481 12.456V18H10.0961V8.082H12.1481V9.216C12.4841 8.808 12.9101 8.49 13.4261 8.262C13.9541 8.034 14.5121 7.92 15.1001 7.92Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3463_2901">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                  <Box>
                    <a href="https://www.facebook.com/cropto.io?locale=tr_TR" target="_blank">
                      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_3456_2830)">
                          <path
                            d="M8.41406 24H4.57069C3.92873 24 3.4065 23.4778 3.4065 22.8358V14.1669H1.16419C0.522188 14.1669 0 13.6445 0 13.0027V9.288C0 8.646 0.522188 8.12381 1.16419 8.12381H3.4065V6.26362C3.4065 4.41919 3.98564 2.85 5.08116 1.72589C6.18164 0.596719 7.71956 0 9.52866 0L12.4598 0.00478125C13.1006 0.00585937 13.622 0.528094 13.622 1.16892V4.61794C13.622 5.25989 13.0999 5.78212 12.4581 5.78212L10.4846 5.78283C9.88275 5.78283 9.72947 5.90348 9.6967 5.94047C9.6427 6.00188 9.57844 6.17522 9.57844 6.65405V8.12367H12.3098C12.5154 8.12367 12.7147 8.17439 12.8858 8.26992C13.2552 8.47631 13.4848 8.8665 13.4848 9.28819L13.4834 13.0029C13.4834 13.6445 12.9611 14.1667 12.3192 14.1667H9.57839V22.8358C9.57844 23.4778 9.05606 24 8.41406 24ZM4.81345 22.593H8.17125V13.537C8.17125 13.1084 8.52009 12.7598 8.94853 12.7598H12.0764L12.0776 9.53086H8.94834C8.51991 9.53086 8.17125 9.18225 8.17125 8.75358V6.65409C8.17125 6.10444 8.22713 5.47931 8.64202 5.00944C9.14339 4.44145 9.93347 4.37592 10.4843 4.37592L12.215 4.37517V1.41136L9.52753 1.407C6.62016 1.407 4.8135 3.26808 4.8135 6.26367V8.75353C4.8135 9.18197 4.46484 9.53081 4.03636 9.53081H1.407V12.7597H4.03636C4.46484 12.7597 4.8135 13.1084 4.8135 13.537L4.81345 22.593Z"
                            fill={theme.text8}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3456_2830">
                            <rect width="13.622" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: '27px',
              width: '100%',
              height: '55px',
              display: 'flex',
              alignItems: 'center',
              borderTop: '1px solid #82B1FF13',
            }}
          >
            <Box
              sx={{
                fontSize: '14.4px',
                fontWeight: 300,
                lineHeight: '18.7px',
                letterSpacing: '0.48px',
                color: theme.text8,
              }}
            >
              2023 Cropto © AgriFintech Financial Technologies Inc. Registered trademark. All rights reserved. Mersis
              Registration No : 00091798703000012023
            </Box>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: { xs: '177px', sm: '10px', md: '-30px', lg: '-12px', xl: '-77px' },
              right: { xs: '-150px', sm: '-100px', md: '0' },
              zIndex: 0,
            }}
          >
            <svg width="397" height="400" viewBox="0 0 397 400" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                opacity="0.05"
                d="M282.4 340.72C257.36 355.36 228.88 363.12 200.08 363.12C195.12 363.12 190.24 362.88 185.36 362.48C199.2 331.76 222.32 305.68 251.84 288.4C276.88 273.76 305.36 266 334.16 266C339.04 266 344 266.24 348.88 266.64C335.04 297.36 311.92 323.44 282.4 340.72ZM67.12 294.64C47.6 267.2 36.8 234.08 36.8 199.92C36.8 165.76 47.6 132.64 67.12 105.2C86.64 132.64 97.44 165.76 97.44 199.92C97.44 234.08 86.64 267.2 67.12 294.64ZM200.08 36.72C228.88 36.72 257.36 44.48 282.4 59.12C311.92 76.4 335.04 102.4 348.88 133.2C344 133.68 339.04 133.84 334.16 133.84C305.36 133.84 276.88 126.08 251.84 111.44C222.32 94.16 199.2 68.16 185.36 37.36C190.24 36.88 195.12 36.72 200.08 36.72ZM233.2 256.72C215.36 267.2 199.76 280 186.48 294.56C162.24 291.04 140.4 278.32 125.2 259.12C130.96 240.4 134.16 220.56 134.16 200C134.16 179.44 130.96 159.52 125.2 140.8C140.4 121.44 162.24 108.88 186.48 105.36C199.76 119.92 215.28 132.72 233.2 143.2C264.96 161.84 299.76 170.64 334.16 170.64C355.28 170.64 376.16 167.28 396.16 160.88C385.28 106.8 352.32 57.52 301.04 27.44C269.28 8.8 234.48 0 200.08 0C178.96 0 158.08 3.36 138.08 9.76C142.56 32 150.8 53.44 162.56 73.04C142.72 78.88 124.56 89.36 109.44 103.6C98.4 83.52 84.08 65.52 67.12 50.48C25.92 87.12 0 140.48 0 199.92C0 259.36 25.92 312.72 67.12 349.44C84.08 334.32 98.4 316.32 109.44 296.24C124.48 310.4 142.64 320.88 162.48 326.8C150.8 346.4 142.56 367.84 138.08 390.08C158.08 396.56 178.96 399.92 200.08 399.92C234.4 399.92 269.2 391.04 301.04 372.48C352.32 342.4 385.28 293.04 396.16 239.04C376.24 232.56 355.28 229.2 334.16 229.2C299.84 229.2 265.04 238.08 233.2 256.64"
                fill={theme.primary6}
              />
            </svg>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}
